import useFormData from "@Totum/QuestionnaireBuilder/Application/hooks/useFormData";
import { DefaultKeys } from "@Totum/QuestionnaireBuilder/Constants";
import useCurrentQuestionnaireId from "@Totum/QuestionnaireBuilder/State/hooks/useCurrentQuestionnaireId";
import { isPresent } from "@Totum/Main/Utils";

/**
 * Presents the `Forms` component with the UI model.
 */
const useFormsPresenter = () => {
    // ** Context ** //
    const [currentQuestionnaireId] = useCurrentQuestionnaireId();

    // ** Hooks ** //
    const { questionnaire, isFetched } = useFormData(currentQuestionnaireId);

    // ** Exports ** //

    return {
        uiModel: {
            // flags
            canShowDetailsForm: isPresent(currentQuestionnaireId),
            canShowAllForms: isPresent(currentQuestionnaireId) && questionnaire.isExistingQuestionnaire,
            shouldShowSkeleton:
                currentQuestionnaireId !== String(DefaultKeys.NEW_QUESTIONNAIRE_ID)
                    ? isPresent(currentQuestionnaireId) && !isFetched
                    : false,
        },
    };
};

export default useFormsPresenter;
